import Specializations from '../components/pages/Specializations/Specializations';
export default Specializations;
